import React, { useCallback } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import { ServicesCategory } from "src/constants";
import {
  CloseIcon,
  PenMenuIcon,
  PlusIcon,
  TrashBinMenuIcon,
  WorkingTimeSidebarInfoIcon,
} from "src/Icons";
import { isImage, isTitle } from "src/utils/validation";

import { AddSubCategorySection } from "./components/AddSubCategorySection";
import { CreateCategorySection } from "./components/CreateCategorySection";
import { EditCategorySection } from "./components/EditCategorySection";

export enum TypeOfServicesModalType {
  CreateCategory,
  EditCategory,
  AddSubCategory,
  DeleteCategory,
  MoveService,
}

const typeOfServiceModalArr = [
  {
    type: TypeOfServicesModalType.CreateCategory,
    label: "Create category",
    id: "0",
    Icon: PenMenuIcon,
  },
  {
    type: TypeOfServicesModalType.EditCategory,
    label: "Edit category",
    id: "1",
    Icon: PenMenuIcon,
  },
  {
    type: TypeOfServicesModalType.AddSubCategory,
    label: "Add subcategory",
    id: "2",
    Icon: PlusIcon,
  },
  {
    type: TypeOfServicesModalType.DeleteCategory,
    label: "Delete category",
    id: "3",
    Icon: TrashBinMenuIcon,
  },
];

interface ModalProps {
  studioId?: string;
  isOpen: boolean;
  data?: ServicesCategory;
  typeOfServiceId: number;
  onClose: any;
  onSubmit: any;
}

export const Modal = ({
  data,
  studioId,
  isOpen,
  typeOfServiceId,
  onClose,
  onSubmit,
}: ModalProps) => {

  const buttonAvailability = (image: string, categoryName: string, subcategoryNames: Array<any>) => {
    const okImahe = image.length > 0
    const okCategory = isTitle(categoryName)
    const okSubcategories = subcategoryNames.every(subcategory => isTitle(subcategory));
    return (
      okImahe && okCategory && okSubcategories
    )
  }

  const renderPopupContent = useCallback(() => {
    const typeOfServices = typeOfServiceModalArr.find(
      ({ id }) => id === `${typeOfServiceId}`
    );

    if (typeOfServices?.type === TypeOfServicesModalType.EditCategory && data) {
      return (
        <EditCategorySection
          studioId={studioId}
          onSubmit={onSubmit}
          onClose={onClose}
          dataSection={data}
          validator={buttonAvailability}
        />
      );
    } else if (
      typeOfServices?.type === TypeOfServicesModalType.AddSubCategory &&
      data
    ) {
      return (
        <AddSubCategorySection
          dataSection={data}
          onSubmit={onSubmit}
          onClose={onClose}
        />
      );
    } else if (
      typeOfServices?.type === TypeOfServicesModalType.CreateCategory &&
      !data
    ) {
      return (
        <CreateCategorySection
          onSubmit={onSubmit}
          onClose={onClose}
          studioId={studioId}
          validator={buttonAvailability}
        />
      );
    }
  }, [data, typeOfServiceId, studioId, onSubmit, onClose]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: "16px",
          width: "632px",
          maxWidth: "632px",
        },
      }}
    >
      <Box
        sx={{
          padding: "32px",
          borderRadius: "16px",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "#B9B9B9",
              marginBottom: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#080808",
                  marginRight: "8px",
                }}
              >
                {typeOfServiceModalArr[typeOfServiceId].label}
              </Typography>
              <WorkingTimeSidebarInfoIcon fontSize="inherit" />
            </Box>
            <Box
              onClick={onClose}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                fontSize: "24px",
                cursor: "pointer",

                "&:hover": {
                  color: "#828282",
                },
              }}
            >
              <CloseIcon fontSize="inherit" />
            </Box>
          </Box>
          <Box>
            <Typography
              sx={{
                color: "#9D9D9D",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Please upload the image, enter category name and add subcategories if needed
            </Typography>
          </Box>
        </Box>

        {renderPopupContent()}
      </Box>
    </Dialog>
  );
};
